import { articles } from '@/mocks/data';
import VideoCard from '@/components/base/VideoCard';
import { categories } from '@/mocks/data';

interface FeaturedSectionProps {
  title: string;
  subtitle: string;
}

export default function FeaturedSection({ title, subtitle }: FeaturedSectionProps) {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || slug;
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              {subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <VideoCard
              key={article.id}
              title={article.title}
              excerpt={article.excerpt}
              slug={article.slug}
              thumbnail={article.thumbnail}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              views={article.views}
              date={article.date}
              featured={true}
            />
          ))}
        </div>
      </div>
    </section>
  );
}